import { AppProvider } from '@/app/providers/provider'
import { AppRouter } from '@/app/router'

const App = () => {
  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  )
}

export { App }
